import { Component, OnInit, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/shared/data/data.service';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ViewChild } from '@angular/core';
import { CarouselComponent } from 'ngx-owl-carousel-o';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-demo-two',
  templateUrl: './home-demo-two.component.html',
  styleUrls: ['./home-demo-two.component.scss']
})
export class HomeDemoTwoComponent implements OnInit {
 
@ViewChild('offerOwl') offerOwl!: any; // CarouselComponent from ngx-owl-carousel-o

  showWelcomeModal = false;
  isClosing = false;

  Categories: any[] = [];
  brands: any[] = [];

  selectedTab: string = 'popular';

  popupBanner: any = null;
  offerCards: any[] = [];
  showOfferPopup = false;

  isClosingPopup = false;

  // loading flags for skeletons
  loadingCategories = true;
  loadingBrands = true;
  newsletterEmail = '';
offerActiveIndex: number = 0;
  constructor(
    private meta: Meta,
    private titleService: Title,
    private http: HttpClient,
    private data: DataService,
    private router: Router
  ) { }

  ngOnInit(): void {

    // ✅ FIX: only show welcome modal on first visit
    const visited = localStorage.getItem('kitchenMagicVisited');

    if (!visited) {
      this.showWelcomeModal = true;
      document.body.style.overflow = 'hidden'; // prevent scroll while modal open
    }

    this.meta.updateTag({
      name: 'description',
      content: 'Welcome to Sangeetha Toys – your trusted destination for premium toys, educational games, creative playsets, and exciting gifts for children. Explore top toy brands and bring joy to every playtime.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'Sangeetha Toys, toy store Chennai, toys online India, educational toys, kids gifts, baby toys, toy brands, creative toys, puzzles, board games'
    });
    this.getProjectCategories();
    this.getBrands();
    this.loadWebsiteBanners();
  }

  slides: string[] = [
    'assets/img/slider/menu1.jpg',
    'assets/img/slider/menu2.jpg',
    'assets/img/slider/menu3.jpg',
  ];

  activeIndex = 0;
  scrollTimeout: any;

  @HostListener('window:wheel', ['$event'])
  onScroll(event: WheelEvent) {
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = setTimeout(() => {
      if (event.deltaY > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }, 80);
  }

  nextSlide() {
    this.activeIndex = (this.activeIndex + 1) % this.slides.length;
  }

  prevSlide() {
    this.activeIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
  }

  // ✅ FIX: proper close with animation + localStorage flag set only on close
  closeWelcomeModal() {
    this.isClosing = true;

    setTimeout(() => {
      this.showWelcomeModal = false;
      this.isClosing = false;
      localStorage.setItem('kitchenMagicVisited', 'true');
      document.body.style.overflow = 'auto';
    }, 400); // match animation duration
  }

  // ✅ NEW: smooth close for offer popup
  closeOfferPopup() {
    this.isClosingPopup = true;

    setTimeout(() => {
      this.showOfferPopup = false;
      this.isClosingPopup = false;
    }, 350);
  }

  // ✅ NEW: switch tabs (kept for potential animation hooks)
  setTab(tab: string) {
    if (this.selectedTab === tab) return;
    this.selectedTab = tab;
  }

  getProjectCategories(): void {

    this.loadingCategories = true;

    this.http.post<any>(
      this.data.base_url + 'category_data/',
      {}
    ).subscribe({

      next: (response) => {

        if (response.status == 1) {

          this.Categories = response.data.map((item: any) => {
            return {
              id: item.category_id,
              name: item.category_name,
              image: this.data.image_url + item.image,
              active: false
            };
          });

        }

        this.loadingCategories = false;
      },

      error: (error) => {
        console.log(error);
        this.loadingCategories = false;
      }

    });

  }

getBrands(): void {

  this.loadingBrands = true;

  this.http.post<any>(
    this.data.base_url + 'supplychain/brand_data/',
    {}
  ).subscribe({

    next: (response: any) => {

      this.brands = response.data.filter(
        (x: any) => x.brand_image
      );

      this.loadingBrands = false;

    },

    error: (error) => {

      console.log(error);

      this.loadingBrands = false;

    }

  });

  }

  loadWebsiteBanners(): void {

    this.http.post<any>(
      this.data.base_url + 'get_website_banners/',
      {}
    ).subscribe(res => {

      if (res.status === 1) {

        const banners = res.data;

        this.popupBanner = banners.find(
          (x: any) => x.position === 'popup'
        );

        this.offerCards = banners.filter(
          (x: any) => x.position === 'home_offer'
        );

        if (this.popupBanner) {
          // ✅ delay slightly so it doesn't collide with welcome modal
          setTimeout(() => {
            this.showOfferPopup = true;
          }, this.showWelcomeModal ? 1500 : 1000);
        }

      }

    });

  }

  // ✅ trackBy functions to optimize *ngFor rendering
  trackByCategory(index: number, item: any): any {
    return item.id ?? index;
  }

  trackByBrand(index: number, item: any): any {
    return item.brand_name ?? index;
  }

  trackByOffer(index: number, item: any): any {
    return item.title ?? index;
  }


goToCategory(category: any) {

  this.router.navigate(
    ['/menu'],
    {
      queryParams: {
        category: category.id
      }
    }
  );

}



subscribeNewsletter() {
  alert(this.newsletterEmail)
  if (!this.newsletterEmail) {
    Swal.fire({
      icon: 'warning',
      title: 'Email Required',
      text: 'Please enter your email address'
    });
    return;
  }

  const payload = {
    email: this.newsletterEmail
  };

  this.http.post(
    `${this.data.base_url}subscribe_newsletter/`,
    payload
  ).subscribe({
    next: (res: any) => {

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: '🎉 Successfully subscribed!',
        showConfirmButton: false,
        timer: 2500
      });

      this.newsletterEmail = '';
    },

    error: () => {
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: 'Subscription failed. Please try again.'
      });
    }
  });
}




offerCarouselOptions: OwlOptions = {
  loop: true,
  autoplay: true,
  autoplayTimeout: 4500,
  autoplayHoverPause: true,
  smartSpeed: 700,
  dots: false,            // we use our own custom dots
  nav: false,             // we use our own prev/next buttons
  margin: 0,
  items: 1,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',
  responsive: {
    0:   { items: 1 },
    768: { items: 1 },
    992: { items: 1 }
  }
};

onOfferTranslated(event: any) {
  // owl-carousel-o emits { startPosition } on the 'translated' output
  this.offerActiveIndex = event.startPosition ?? 0;
}

offerPrev() {
  if (this.offerOwl) {
    this.offerOwl.prev();
  }
}
 
offerNext() {
  if (this.offerOwl) {
    this.offerOwl.next();
  }
}
 
goToOfferSlide(index: number) {
  this.offerActiveIndex = index;
  if (this.offerOwl) {
    this.offerOwl.to(this.offerCards[index]?.id || String(index));
  }
}

}
